import { render } from "./BallotManagement.vue?vue&type=template&id=a312f17c"
import script from "./BallotManagement.vue?vue&type=script&lang=js"
export * from "./BallotManagement.vue?vue&type=script&lang=js"

import "./BallotManagement.vue?vue&type=style&index=0&id=a312f17c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__